import {TimeDuration} from "~/lib/time";

type ClientFunctionalities = {
  allowHomepageEdition?: boolean;
  [key:string]: unknown;
}

export class Client {

  public uuid:string = null;
  public name:string = null;
  public description:string = null;
  public code:string = null;

  public subscription:ClientSubscription = null;
  public territory = null;
  public geomVersion: Record<string, string>  = null;

  public createdAt: Date = null
  public siret: string = null
  public active:boolean = null;
  public functionalities: ClientFunctionalities = null;

  constructor(payload) {

    this.uuid = payload.uuid;
    this.name = payload.name;
    this.description = payload.clientProfile?.account_description;
    this.code = payload.clientProfile?.code;
    this.territory = payload.territory;
    this.geomVersion = payload.functionalities.geomVersion;
    this.createdAt = payload.createdAt;
    this.siret = payload.siret;
    this.active = payload.active;
    this.functionalities = payload.functionalities;

    if( payload.clientProfile?.subscription ){
      this.subscription = {
        startDate: new Date(payload.clientProfile.subscription.startDate),
        duration: payload.clientProfile.subscription.duration ? TimeDuration.fromPayload(payload.clientProfile.subscription.duration) : null,
        autoRenew: payload.clientProfile.subscription.autoRenew,
        offerLabel: payload.clientAbout?.offerName,
        distributedBy: payload.clientAbout?.distributor,
      };
    }
  }

}


export type ClientSubscription = {
  startDate:Date;
  duration:TimeDuration;
  autoRenew:boolean;
  offerLabel: string;
  distributedBy: string;
}
